import { IGNORED_GLOBAL_ERROR_PATTERNS } from 'data/error-log-constants';
import { reportError } from 'utils/error-log/error-log-reporter';
import { normalizeError } from 'utils/error-log/serialize';

let installed = false;

function isIgnoredMessage(message: string): boolean {
  return IGNORED_GLOBAL_ERROR_PATTERNS.some((pattern) => pattern.test(message));
}

function handleWindowError(event: ErrorEvent) {
  const cause = event.error ?? event.message;
  const message = normalizeError(cause).message || event.message;
  if (!message || isIgnoredMessage(message)) {
    return;
  }
  reportError({ source: 'uncaughtError', message, cause });
}

function handleUnhandledRejection(event: PromiseRejectionEvent) {
  const { message } = normalizeError(event.reason);
  if (!message || isIgnoredMessage(message)) {
    return;
  }
  reportError({ source: 'unhandledRejection', message, cause: event.reason });
}

export function installGlobalErrorHandlers() {
  if (installed || typeof window === 'undefined') {
    return;
  }
  installed = true;
  window.addEventListener('error', handleWindowError);
  window.addEventListener('unhandledrejection', handleUnhandledRejection);
}
